import styled from "styled-components";
import { Dropdown } from "primereact/dropdown";

export const StyledDropdown = styled(Dropdown)`
  min-width: 100px;
  background: transparent !important;

  .p-inputtext {
    background: transparent !important;
    padding: 0.35rem 0.45rem !important;
  }
`;
